<template>
  <section class="viewsrhqyAppointDelivery_DeliveryRecordDetail p-4 space-y-2">
    <viewTitle
      title="业务管理 / 预约记录管理 / 预约送货记录 / 预约送货记录详情"
      :showReturn="true"
    >
      <template slot="return">
        <el-button
          class="w-20"
          @click="$router.go(-1)"
          plain
          size="small"
          style="font-size: 14px;"
          >返回</el-button
        >
        <el-button
          @click="onRelatedOrder"
          type="primary"
          size="small"
          style="font-size: 14px;"
          v-if="vehicleContainerNumber"
          >查看相关记录</el-button
        >
        <el-button
          v-if="![8, 7].includes(detail.state)"
          class="w-20"
          @click="onClose"
          size="small"
          type="danger"
          v-has="['c-booking-delivery-close']"
          >关闭</el-button
        >
      </template>
    </viewTitle>
    <el-row>
      <el-form :model="detail" :label-width="labelWidth">
        <!-- 左边 -->
        <el-col :span="10">
          <div class="text-lg">基本信息</div>
          <el-form-item v-if="detail.ship_name" label="木片厂名">
            <span class="text-gray-500">{{ detail.ship_name || "--" }}</span>
          </el-form-item>
          <el-form-item label="供应商名称">
            <span class="text-gray-500">{{
              detail.supplier_name || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="供应商编号">
            <span class="text-gray-500">{{
              detail.supplier_code || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="基地">
            <span class="text-gray-500">{{ detail.company_name || "--" }}</span>
          </el-form-item>
          <el-form-item label="订单号">
            <span class="text-gray-500">{{ detail.order_code || "--" }}</span>
          </el-form-item>
          <el-form-item label="是否区域价">
            <span class="text-gray-500">{{
              detail.clock ? detail.clock.is_area_price : "否"
            }}</span>
          </el-form-item>
          <el-form-item label="订单类型">
            <span class="text-gray-500">
              {{
                detail.order_type === "CD"
                  ? "木片"
                  : detail.order_type === "IB"
                  ? "国废"
                  : detail.order_type === "NB"
                  ? "化辅"
                  : "其他"
              }}
            </span>
          </el-form-item>
          <el-form-item label="申请时间">
            <span class="text-gray-500">{{
              detail.create_time | timeFormat
            }}</span>
          </el-form-item>
          <el-form-item label="车辆业务类型">
            <span
              class="text-gray-500"
              v-for="item in detail.business.sub_business"
              :key="item.id"
            >
              {{ item.name }}
            </span>
          </el-form-item>
          <el-form-item v-if="detail.chip_type" label="物料类型">
            <span class="text-gray-500">{{ detail.chip_type || "--" }}</span>
          </el-form-item>

          <div class="text-lg">预约信息</div>
          <el-form-item label="预约号">
            <span class="text-gray-500">{{ detail.code || "--" }}</span>
          </el-form-item>
          <el-form-item label="预约状态">
            <span class="text-gray-500">{{
              businessState[detail.state] || "--"
            }}</span>
          </el-form-item>
          <el-form-item label="司机手机号">
            <span class="text-gray-500">{{ detail.info.contact || "--" }}</span>
          </el-form-item>
          <el-form-item label="送货日期">
            <span class="text-gray-500">{{
              moment(detail.booking_day, "YYYYMMDD").format("YYYY-MM-DD") ||
                "--"
            }}</span>
          </el-form-item>
          <el-form-item label="送货时间段">
            <span class="text-gray-500">
              {{ detail.booking_time.begin_time }} ~
              {{ detail.booking_time.end_time }}
            </span>
          </el-form-item>
          <el-form-item
            v-if="detail.order_type === 'NB' || detail.warehouse_name"
            label="卸货点"
          >
            <span class="text-gray-500">{{ detail.warehouse_name || "--" }}</span>
          </el-form-item>

          <div class="text-lg">车辆信息</div>
          <el-form-item label="车牌号">
            <span class="text-gray-500">
              {{ detail.info.license_plate || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="集装箱号">
            <span class="text-gray-500">
              {{ vehicleContainerNumber || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="车辆类型">
            <span class="text-gray-500">
              {{ detail.info.vehicle_type | formatVehicleType(vehicleTypes) }}
            </span>
          </el-form-item>
          <el-form-item label="司机姓名">
            <span class="text-gray-500">
              {{ detail.info.name || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="身份证号">
            <span class="text-gray-500">
              {{ detail.info.id_card || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="副驾姓名">
            <span class="text-gray-500">
              {{ firstReportEntourage.name || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="副驾手机号">
            <span class="text-gray-500">
              {{ firstReportEntourage.contact || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="副驾身份证号">
            <span class="text-gray-500">
              {{ firstReportEntourage.id_card || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="货物种类">
            <span class="text-gray-500">
              {{ detail.business_goods_name || "--" }}
            </span>
          </el-form-item>
          <el-form-item label="送货单号">
            <span class="text-gray-500">
              {{ detail.deliver_code || "--" }}
            </span>
          </el-form-item>
          <template v-if="showGuofeiSection">
            <div class="text-lg">国废信息</div>
            <el-form-item label="采购订单行项目">
              <span class="text-gray-500">{{ detail.order_item || "--" }}</span>
            </el-form-item>
            <el-form-item label="包数">
              <span class="text-gray-500">{{ detail.package_count || "--" }}</span>
              <el-button
                v-if="showGuofeiPackageCountEdit"
                v-has="['c-booking-delivery-change']"
                @click="onEditGuofeiFields('package_count')"
                size="mini"
                type="text"
              >修改</el-button>
            </el-form-item>
            <el-form-item label="大小包">
              <span class="text-gray-500">{{ detail.is_small_package_name || "--" }}</span>
            </el-form-item>
            <el-form-item label="承运商">
              <span class="text-gray-500">{{ detail.carrier_type_name || "--" }}</span>
            </el-form-item>
          </template>
          <div class="text-lg">变更日志</div>
          <el-form-item
            v-for="item in detail.log"
            :key="item.id"
            label-width="50px"
          >
            <span class="text-gray-500">
              <span v-html="item.note"></span>（{{
                item.create_time | timeFormat
              }}）
            </span>
          </el-form-item>
        </el-col>
        <!-- 右边 -->
        <el-col :span="14">
          <template v-if="detail.clock">
            <span class="text-lg">发货打卡</span>
            <el-form-item label="数据来源">
              <span class="text-gray-500">{{
                detail.clock.position_source == 1 ? "北斗" : "APP"
              }}</span>
            </el-form-item>
            <el-form-item label="车头车牌号">
              <span class="text-gray-500">{{
                detail.info.license_plate || "--"
              }}</span>
            </el-form-item>
            <el-form-item label="车牌类型">
              <span class="text-gray-500">{{
                detail.clock.license_plate_type | formatLicensePlateType
              }}</span>
            </el-form-item>
            <el-form-item label="打卡时间">
              <span class="text-gray-500">{{
                detail.clock.clock_time | timeFormat
              }}</span>
            </el-form-item>
            <el-form-item label="打卡地点">
              <span class="text-gray-500">{{
                detail.clock.address || "--"
              }}</span>
            </el-form-item>
          </template>
          <template v-if="detail.outward_time">
            <span class="text-lg">出车信息</span>
            <el-form-item label="出车确认时间">
              <span class="text-gray-500">{{
                detail.outward_time | timeFormat
              }}</span>
            </el-form-item>
            <el-form-item label="出车确认图片">
              <template v-if="detail.outward_file.length > 0">
                <div class="inline-flex flex-wrap pt-2" style="width: 440px">
                  <el-image
                    v-for="file in detail.outward_file"
                    :key="file.id"
                    style="width: 100px; height: 100px"
                    :src="file.real_path"
                    :preview-src-list="outwardPreviewSrcList"
                    fit="fill"
                    class="mr-2 mb-2"
                  >
                    <template slot="error">
                      <div
                        class="el-image__error"
                        style="flex-direction: column;line-height: 2;"
                      >
                        <span>加载失败</span>
                        <el-button
                          @click.stop="onDownload(file.real_path)"
                          size="mini"
                          type="primary"
                          >下载</el-button
                        >
                      </div>
                    </template>
                  </el-image>
                </div>
              </template>
              <template v-else>--</template>
            </el-form-item>
          </template>
          <template v-if="detail.queue">
            <span class="text-lg">排队信息</span>
            <el-form-item label="进厂前排队">
              <span class="text-gray-500">
                总排队：{{ detail.queue.total_seq }}（<span
                  class="text-gray-500"
                  v-for="item in detail.business.sub_business"
                  :key="item.id"
                >
                  {{ item.name }} </span
                >：{{ detail.queue.business_seq }}）
              </span>
            </el-form-item>
            <el-form-item label="进厂后排队">
              <span class="text-gray-500">
                {{ detail.queue.warehouse_name || "--" }}
                <template v-if="detail.queue.warehouse_name">
                  ({{ detail.report_time | timeFormat("MM月DD日") }}：{{
                    detail.queue.unload_seq || ""
                  }})
                </template>
              </span>
            </el-form-item>
          </template>
          <template v-if="detail.pound.pound_code">
            <span class="text-lg">过磅信息</span>
            <el-form-item label="磅单号">
              <span class="text-gray-500 mr-2">{{
                detail.pound.pound_code || "--"
              }}</span>
              <el-button v-has="['c-booking-delivery-uPound']" @click="onEditPound" v-if="detail.pound.pound_code" size="mini" type="text">修改磅单号</el-button>
            </el-form-item>
            <el-form-item label="进厂前重量">
              <template v-if="detail.pound.first_weight">
                <c-link @click="onPoundDetail(detail.pound.first_weight_id)"
                  >{{ detail.pound.first_weight }}T</c-link
                >
              </template>
              <span v-else class="text-gray-500">--</span>
            </el-form-item>
            <el-form-item label="集装箱号">
              <span class="text-gray-500">
                {{ poundContainerNumber || "--" }}
              </span>
            </el-form-item>

            <el-form-item label="出厂后重量">
              <template v-if="detail.pound.second_weight">
                <c-link @click="onPoundDetail(detail.pound.second_weight_id)"
                  >{{ detail.pound.second_weight }}T</c-link
                >
              </template>
              <span v-else class="text-gray-500">--</span>
            </el-form-item>
            <el-form-item label="净重">
              <span v-if="detail.pound.weight" class="text-gray-500"
                >{{ detail.pound.weight }}T</span
              >
              <span v-else>--</span>
            </el-form-item>
            <el-form-item label="进厂时间">
              <span class="text-gray-500">
                {{ detail.pound.first_weighing_time | timeFormat }}
              </span>
            </el-form-item>
            <el-form-item label="出厂时间">
              <span class="text-gray-500">{{
                detail.pound.second_weighing_time | timeFormat
              }}</span>
            </el-form-item>
          </template>
          <el-form-item label="是否逗留超时车辆">
            <span class="text-gray-500">{{
              detail.is_stranded === 1 ? "是" : "否"
            }}</span>
          </el-form-item>
          <template v-if="detail.queue">
            <el-form-item label="优先处理">
              <span class="text-gray-500">{{
                detail.queue.is_priority === 1 ? "是" : "否"
              }}</span>
            </el-form-item>
            <el-form-item label="优先处理原因">
              <span class="text-gray-500">{{
                detail.queue.priority_reason || "--"
              }}</span>
            </el-form-item>
            <span class="text-lg">取样信息</span>
            <el-form-item label="取样地点">
              <span class="text-gray-500">{{
                detail.queue.sampling_point_name || "--"
              }}</span>
            </el-form-item>
            <el-form-item label="是否系统加抽">
              <span class="text-gray-500">{{
                detail.queue.is_system_pumping == 0 ? "否" : "是"
              }}</span>
            </el-form-item>
            <el-form-item label="是否临时加抽">
              <span class="text-gray-500">{{
                detail.queue.is_tmp_pumping == 0 ? "否" : "是"
              }}</span>
            </el-form-item>
          </template>
          <template v-if="detail.sampling_list">
            <div v-for="item in detail.sampling_list" :key="item.id">
              <el-form-item
                :label="
                  `取样员${
                    item.sampling_type == 2
                      ? '(加抽)'
                      : item.sampling_type == 3
                      ? '(临时加抽)'
                      : ''
                  }`
                "
              >
                <span class="text-gray-500">{{
                  item.sampler_name || "--"
                }}</span>
              </el-form-item>
              <el-form-item label="取样时间">
                <span class="text-gray-500">{{
                  item.sampling_time | timeFormat
                }}</span>
              </el-form-item>
              <el-form-item label="特采">
                <span class="text-gray-500">{{
                  item.is_special_sampling == 1 ? "是" : "否"
                }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span class="text-gray-500">{{ item.remark || "--" }}</span>
              </el-form-item>
            </div>
            <!-- 退货状态保存在预约队列，取样详情按当前队列事实展示，和 PDA 确认弹窗保持一致。 -->
            <el-form-item label="退货">
              <span class="text-gray-500">{{
                detail.queue.is_return == 1 ? "是" : "否"
              }}</span>
            </el-form-item>
            <el-form-item label="部分退货">
              <span class="text-gray-500">{{
                detail.queue.is_partial_return == 1 ? "是" : "否"
              }}</span>
            </el-form-item>
          </template>
          <template v-if="detail.queue">
            <span class="text-lg">装卸信息</span>
            <el-form-item label="装卸点">
              <span class="text-gray-500">{{
                detail.queue.warehouse_name || "--"
              }}</span>
              <el-button
                v-if="showWarehouseEditButton"
                v-has="['c-booking-delivery-updateWare']"
                @click="onEditWarehouse"
                size="mini"
                type="text"
              >修改</el-button>
            </el-form-item>
            <el-form-item label="外观确认员">
              <span class="text-gray-500">
                {{ detail.queue.begin_unloader_name || "--" }}
              </span>
            </el-form-item>
            <el-form-item label="装卸员">
              <span class="text-gray-500">
                {{ detail.queue.end_unloader_name || "--" }}
              </span>
            </el-form-item>
            <el-form-item label="外观确认时间">
              <span class="text-gray-500">
                {{ detail.queue.unload_begin_time | timeFormat }}
              </span>
            </el-form-item>
            <el-form-item v-if="!isGuofei" label="质检图片">
              <template
                v-if="
                  detail.inspection_files && detail.inspection_files.length > 0
                "
              >
                <div
                  class="inline-flex flex-wrap pt-2"
                  style="max-width: 440px"
                >
                  <el-image
                    v-for="file in detail.inspection_files"
                    :key="file.id"
                    style="width: 100px; height: 100px"
                    :src="file.real_path"
                    :preview-src-list="previewSrcList"
                    fit="fill"
                    class="mr-2 mb-2"
                  >
                    <template slot="error">
                      <div
                        class="el-image__error"
                        style="flex-direction: column;line-height: 2;"
                      >
                        <span>加载失败</span>
                        <el-button
                          @click.stop="onDownload(file.real_path)"
                          size="mini"
                          type="primary"
                          >下载</el-button
                        >
                      </div>
                    </template>
                  </el-image>
                </div>
              </template>
              <span class="mr-2" v-else>--</span>
              <el-button
                v-has="['c-booking-delivery-uFile']"
                @click="onEditInspectionFile"
                type="primary"
                size="small"
                >修改</el-button
              >
            </el-form-item>
            <el-form-item label="外观确认备注">
              <span class="text-gray-500">
                {{ detail.queue.begin_unload_remark || "--" }}
              </span>
            </el-form-item>
            <el-form-item label="装卸结束时间">
              <span class="text-gray-500">
                {{ detail.queue.unload_end_time | timeFormat }}
              </span>
            </el-form-item>
            <template v-if="detail.pound">
              <el-form-item label="放柜区域">
                <span class="text-gray-500">
                  <!-- SAP推送放柜区域 -->
                  {{ detail.put_area_name || "--" }}
                </span>
              </el-form-item>
              <el-form-item label="备注">
                <span class="text-gray-500">
                  <!-- SAP推送备注 -->
                  {{ detail.sap_remark || "--" }}
                </span>
              </el-form-item>
            </template>
            <el-form-item label="存储地点">
              <span class="text-gray-500">
                {{ queueStoragePointDisplay || "--" }}
              </span>
            </el-form-item>
            <el-form-item label="垛位">
              <span class="text-gray-500">
                <template v-if="detail.queue.stack_position_name">
                  {{ detail.queue.stack_position_id }}（{{
                    detail.queue.stack_position_name
                  }}）
                </template>
                <template v-else>--</template>
              </span>
            </el-form-item>
            <el-form-item label="卸货班组">
              <span class="text-gray-500">
                {{ detail.queue.unload_team_name || "--" }}
              </span>
            </el-form-item>
            <el-form-item
              v-if="showHuafuSection && detail.queue.ton_bucket_count !== '' && detail.queue.ton_bucket_count !== null && detail.queue.ton_bucket_count !== undefined"
              label="吨包/桶数量"
            >
              <span class="text-gray-500">
                {{ detail.queue.ton_bucket_count }}
              </span>
            </el-form-item>
            <el-form-item
              v-if="showHuafuSection && detail.latest_quality_result"
              label="质检结果"
            >
              <span class="text-gray-500">
                {{ detail.latest_quality_result }}
              </span>
            </el-form-item>
            <el-form-item v-if="!showHuafuSection" label="退货">
              <span class="text-gray-500">
                {{ detail.queue.is_return === 1 ? "是" : "否" }}
              </span>
            </el-form-item>
            <el-form-item v-if="!showHuafuSection" label="部分退货">
              <span class="text-gray-500">
                {{ detail.queue.is_partial_return === 1 ? "是" : "否" }}
              </span>
            </el-form-item>
            <el-form-item label="异常备注">
              <span class="text-gray-500">
                {{ detail.queue.unload_abnormal_remark || "无" }}
              </span>
            </el-form-item>
            <el-form-item label="卸货备注">
              <span class="text-gray-500">
                {{ detail.queue.unload_remark || "--" }}
              </span>
            </el-form-item>
          </template>
          <template v-if="isGuofei">
            <span class="text-lg">质检信息</span>
            <el-form-item label="抽包号">
              <span class="text-gray-500">{{ detail.package_no || "--" }}</span>
            </el-form-item>
            <el-form-item label="临时加抽编号">
              <span class="text-gray-500">{{
                detail.temp_package_no ||
                  (detail.first_inbound_pound && detail.first_inbound_pound.temp_package_no) ||
                  "--"
              }}</span>
            </el-form-item>
            <el-form-item label="抽包总数">
              <span class="text-gray-500">{{
                detail.temp_package_count ||
                  (detail.first_inbound_pound && detail.first_inbound_pound.temp_package_count) ||
                  "--"
              }}</span>
            </el-form-item>
            <el-form-item label="测水结果">
              <span class="text-gray-500">{{ detail.microwave_moisture || "--" }}</span>
            </el-form-item>
            <el-form-item label="测量时间">
              <span class="text-gray-500">{{
                detail.microwave_measure_datetime
                  ? moment.unix(detail.microwave_measure_datetime).format("YYYY-MM-DD HH:mm:ss")
                  : "--"
              }}</span>
            </el-form-item>
            <el-table
              v-if="qualityInfoList.length > 0"
              :data="qualityInfoList"
              border
              class="quality-info-table mt-2"
              size="mini"
              style="width: 100%;"
            >
              <el-table-column label="上传时间" width="160">
                <template slot-scope="{ row }">
                  <span class="text-gray-500">{{ row.create_time | timeFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="类型" width="100">
                <template slot-scope="{ row }">
                  <span class="text-gray-500">{{ resolveQualityRecordTitle(row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" min-width="160">
                <template slot-scope="{ row }">
                  <span class="text-gray-500">{{ resolveQualityRemark(row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="照片" min-width="260">
                <template slot-scope="{ row }">
                  <template v-if="resolveQualityFiles(row).length > 0">
                    <div class="inline-flex flex-wrap pt-2">
                      <el-image
                        v-for="(file, index) in resolveQualityFiles(row)"
                        :key="file.id || resolveQualityFileUrl(file) || index"
                        style="width: 80px; height: 80px"
                        :src="resolveQualityFileUrl(file)"
                        :preview-src-list="getQualityInfoPreviewList(row)"
                        fit="fill"
                        class="mr-2 mb-2"
                      >
                        <template slot="error">
                          <div class="el-image__error" style="flex-direction: column;line-height: 2;">
                            <span>加载失败</span>
                            <el-button
                              @click.stop="onDownload(resolveQualityFileUrl(file))"
                              size="mini"
                              type="primary"
                            >下载</el-button>
                          </div>
                        </template>
                      </el-image>
                    </div>
                  </template>
                  <span v-else class="text-gray-500">--</span>
                </template>
              </el-table-column>
            </el-table>
            <el-form-item v-else label="上传记录">
              <span class="text-gray-500">--</span>
            </el-form-item>
          </template>
        </el-col>
      </el-form>
    </el-row>
    <editInspectionFile ref="editInspectionFile" @ok="getDetail" />
    <editPoundModal ref="editPoundModal" @ok="getDetail"/>
    <editGuofeiFields ref="editGuofeiFields" @ok="getDetail" />
    <editWarehouse ref="editWarehouse" @ok="getDetail" />
  </section>
</template>

<script>
import editInspectionFile from "./components/editInspectionFile.vue";
import editPoundModal from "./components/editPoundModal.vue";
import editGuofeiFields from "./components/editGuofeiFields.vue";
import editWarehouse from "./components/editWarehouse.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  props: [],

  data() {
    return {
      moment,
      labelWidth: "130px",
      detail: {
        clock: {},
        info: {},
        business: {
          sub_business: []
        },
        booking_time: {},
        file: [],
        log: [],
        queue: {},
        pound: {},
        order_type: "",
        order_item: "",
        chip_code: "",
        chip_type: "",
        package_count: "",
        is_small_package_name: "",
        carrier_type_name: "",
        package_no: "",
        temp_package_no: "",
        temp_package_count: "",
        put_area_name: "",
        microwave_moisture: "",
        microwave_measure_datetime: 0,
        quality_info_list: []
      },
      stateList: [
        { label: "待出车", value: "0" },
        { label: "待登记", value: "1" },
        { label: "待授权", value: "41" },
        { label: "待叫号", value: "42" },
        { label: "待进厂", value: "43" },
        { label: "待入厂磅", value: "48" },
        { label: "待测水", value: "49" },
        { label: "待取样", value: "44" },
        { label: "待装卸", value: "45" },
        { label: "待出厂", value: "46" },
        { label: "已完成", value: "8" },
        { label: "已过号", value: "47" },
        { label: "已关闭", value: "7" }
      ]
    };
  },

  computed: {
    ...mapGetters(["businessState", "vehicleTypes"]),
    previewSrcList() {
      const { inspection_files } = this.detail;
      if (inspection_files && inspection_files.length > 0) {
        return inspection_files.map(item => item.real_path);
      }
      return [];
    },
    outwardPreviewSrcList() {
      const { outward_file } = this.detail;
      if (outward_file && outward_file.length > 0) {
        return outward_file.map(item => item.real_path);
      }
      return [];
    },
    vehicleContainerNumber() {
      const { container_number, info = {} } = this.detail;
      return container_number || info.container_number || "";
    },
    // 预约详情页固定展示首位副驾，避免模板里散落数组判空与下标访问逻辑。
    firstReportEntourage() {
      const reportEntourage = this.detail.report_entourage;
      if (!Array.isArray(reportEntourage) || reportEntourage.length === 0) {
        return {};
      }

      return reportEntourage[0] || {};
    },
    poundContainerNumber() {
      const { pound = {} } = this.detail;
      return pound.container_number || "";
    },
    // 国废信息区块只在国废订单展示，避免木片等业务因复用字段误显示国废信息。
    showGuofeiSection() {
      return this.detail.order_type === "IB";
    },
    showHuafuSection() {
      return this.detail.order_type === "NB";
    },
    // 化辅详情页的存储地点按“编码-名称”维护值直接回显，避免把内部装卸点 ID 暴露给现场人员。
    queueStoragePointDisplay() {
      const queue = this.detail.queue || {};
      const storagePointId = (queue.storage_point_id || "").trim();
      const storagePointName = (queue.storage_point_name || "").trim();

      if (this.showHuafuSection) {
        return storagePointName || storagePointId;
      }
      if (storagePointId && storagePointName && storagePointId !== storagePointName) {
        return `${storagePointId}（${storagePointName}）`;
      }
      return storagePointName || storagePointId;
    },
    // 国废详情仅包数支持就地修改按钮，交互与原有磅单号修改入口保持一致。
    showGuofeiPackageCountEdit() {
      return this.showGuofeiSection;
    },
    // 国废详情仅放柜区域支持就地修改按钮，交互与原有磅单号修改入口保持一致。
    showGuofeiPutAreaEdit() {
      return this.showGuofeiSection;
    },
    // 详情页装卸点修改入口沿用旧权限，国废有队列后也允许直接修改。
    showWarehouseEditButton() {
      const queue = this.detail.queue || {};
      const isGuofeiOrder = this.detail.order_type === "IB";
      const isHuafuOrder = this.detail.order_type === "NB";
      return (
        !!this.detail.id &&
        [43, 44, 45, 49].includes(Number(this.detail.state)) &&
        (isGuofeiOrder || isHuafuOrder || !!queue.warehouse_id || !!queue.sampling_point_id)
      );
    },
    // 国废不走取样主流程，因此装卸点修改统一走“仅装卸点”模式。
    isWarehouseEditUnloadOnly() {
      return ["IB", "NB"].includes(this.detail.order_type) || Number(this.detail.state) === 45;
    },
    isGuofei() {
      return this.detail.order_type === "IB";
    },
    // 质检信息优先使用后端新字段，回退旧 abnormal_list 兼容未升级接口。
    qualityInfoList() {
      return this.detail.quality_info_list || this.detail.abnormal_list || [];
    }
  },

  watch: {},

  components: {
    editInspectionFile,
    editPoundModal,
    editGuofeiFields,
    editWarehouse
  },

  mixins: [],

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  activated() {},

  filters: {
    formatAddress(data) {
      const { province, city, district } = data;
      if (province && city && district) {
        return `${province}${city}${district}`;
      }
      return "--";
    },
    timeFormat(time, style = "YYYY-MM-DD HH:mm:ss") {
      return time ? moment.unix(time).format(style) : "--";
    },
    formatLicensePlateType(type) {
      const map = {
        1: "蓝牌车",
        2: "黄牌车",
        3: "黄绿车"
      };
      return map[type] || "--";
    },
    formatVehicleType(type, data) {
      const typeItem = data.find(e => e.id == type);
      if (typeItem) {
        return typeItem.name;
      }
      return "--";
    }
  },

  deactivated() {},

  methods: {
    // 下载图片或附件。
    onDownload(url) {
      window.open(url);
    },
    // 解析质检图片地址，兼容 PDA 与 PC 不同接口时期返回的附件字段。
    resolveQualityFileUrl(file) {
      if (!file) {
        return "";
      }
      if (typeof file === "string") {
        return file;
      }
      return (
        file.real_path ||
        file.url ||
        file.src ||
        file.preview_url ||
        file.thumb_url ||
        ""
      );
    },
    // 获取一条质检记录中的有效图片，兼容 files、complaint_files 等历史字段。
    resolveQualityFiles(item) {
      const fileSources = [
        item && item.files,
        item && item.complaint_files,
        item && item.file_list,
        item && item.images,
        item && item.file
      ];
      const files = fileSources.find(source => {
        if (Array.isArray(source)) {
          return source.length > 0;
        }
        return source && typeof source === "object";
      });
      let normalizedFiles = [];
      if (Array.isArray(files)) {
        normalizedFiles = files;
      } else if (files) {
        // 关键步骤：单个文件对象直接作为一张图，文件映射对象再展开。
        normalizedFiles = this.resolveQualityFileUrl(files)
          ? [files]
          : Object.values(files);
      }
      return normalizedFiles.filter(file => !!this.resolveQualityFileUrl(file));
    },
    // 解析质检上传记录类型，兼容后端未返回 quality_type_name 或旧数据只带备注的情况。
    resolveQualityRecordTitle(item) {
      if (!item) {
        return "质检记录";
      }
      if (item.quality_type_name || item.file_label) {
        return item.quality_type_name || item.file_label;
      }
      const qualityType = String(item.quality_type || "");
      const sourceType = String(item.type || "");
      if (qualityType === "inspection" || sourceType === "quality_inspection") {
        return "质检照片";
      }
      if (qualityType === "abnormal" || sourceType === "quality_abnormal") {
        return "异常照片";
      }
      const description = `${item.description || item.remark || ""}`;
      if (description.includes("异常")) {
        return "异常照片";
      }
      if (description.includes("质检")) {
        return "质检照片";
      }
      return "质检记录";
    },
    // 质检备注只展示用户录入内容，不再用类型文案或默认文案兜底。
    resolveQualityRemark(item) {
      if (!item) {
        return "--";
      }
      const remark = item.description || item.remark || "";
      return remark || "--";
    },
    // 提取当前质检信息行的图片预览列表，避免模板里重复拼装。
    getQualityInfoPreviewList(item) {
      return this.resolveQualityFiles(item)
        .map(file => this.resolveQualityFileUrl(file))
        .filter(url => !!url);
    },
    // 打开质检图片编辑弹窗。
    onEditInspectionFile() {
      this.$refs.editInspectionFile.onOpen(this.detail);
    },
    // 打开相关预约记录列表，并带上可用的检索条件。
    onRelatedOrder() {
      const {
        // supplier_name,
        order_code
        // info: {
        //   license_plate
        // }
      } = this.detail;
      let params = {
        keyword: order_code
        // order_code,
        // license_plate
      };
      if (this.vehicleContainerNumber) {
        params["container_number"] = this.vehicleContainerNumber;
      }
      const condition = Object.keys(params)
        .map(key => `${key}=${params[key]}`)
        .join("&");
      let url = `/rhqy/service/AppointDeliveryRecord/List?${condition}`;
      window.open(this.$router.resolve(url).href, "_blank");
    },
    // 获取预约送货记录详情，并整理过磅相关展示字段。
    async getDetail() {
      const res = await this.$common.http({
        url: "/api/queue/admin/query_booking_detail",
        data: {
          booking_info_id: this.$route.params.booking_info_id
        }
      });
      const { pound, ...data } = res.data.data;
      let poundInfo = {};
      // 仅提取已推送 SAP 的有效过磅记录，避免无效数据影响详情展示。
      pound
        .filter(e => e.push_sap_state == 2 || e.push_sap_state == 4)
        .map(item => {
          if (item.pound_code) {
            poundInfo.pound_code = item.pound_code;
            if (item.weight_type == 1) {
              poundInfo.first_weighing_time = item.weighing_time;
              poundInfo.first_weight = item.weight;
              poundInfo.first_weight_id = item.id;
            }
            if (item.weight_type == 2) {
              poundInfo.second_weighing_time = item.weighing_time;
              poundInfo.second_weight = item.weight;
              poundInfo.second_weight_id = item.id;
            }
            if (item.put_area) {
              poundInfo.put_area = item.put_area;
            }
            if (item.container_number) {
              poundInfo.container_number = item.container_number;
            }
            if (item.remark) {
              poundInfo.pound_remark = item.remark;
            }
          }
        });
      // 同时存在一次、二次过磅时，计算净重供页面直接展示。
      if (poundInfo.first_weight && poundInfo.second_weight) {
        poundInfo.weight = (
          Number(poundInfo.first_weight) - Number(poundInfo.second_weight)
        ).toFixed(2);
      }
      const smallPackageName =
        data.is_small_package_name === "小包" || data.is_small_package_name === "大包"
          ? data.is_small_package_name
          : data.is_small_package_name === "是"
          ? "小包"
          : data.is_small_package_name === "否"
          ? "大包"
          : data.is_small_package === "X"
          ? "小包"
          : "大包";
      // 关键步骤：替换为新的 detail 引用，避免 Vue2 因复用同一对象导致新增字段不触发区块刷新。
      this.detail = {
        ...this.detail,
        ...data,
        chip_type: data.chip_type === "null" ? null : data.chip_type,
        chip_code: data.chip_code === "null" ? null : data.chip_code,
        // 关键步骤：前端兜底统一旧“是/否”和新“大包/小包”口径，避免三端展示不一致。
        is_small_package_name: smallPackageName,
        pound: poundInfo
      };
    },
    // 关闭当前预约送货记录。
    onClose() {
      this.$prompt("确认关闭此预约送货记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        inputValidator: value => {
          if (!value) {
            return false;
          }
          return true;
        },
        inputErrorMessage: "关闭原因不能为空！"
      }).then(async ({ value }) => {
        await this.$common.http({
          url: "/api/queue/admin/close",
          data: {
            booking_id: this.detail.id,
            reason: value
          }
        });
        // this.$common.pcToastSuccess("关闭预约记录成功！");
        // this.getDetail();
        location.reload();
      });
    },
    // 打开过磅详情页。
    onPoundDetail(id) {
      window.open(
        this.$router.resolve(`/rhqy/service/WeighConfirmManage/Detail/${id}`)
          .href,
        "_blank"
      );
    },
    // 打开磅单号编辑弹窗。
    onEditPound() {
      this.$refs.editPoundModal.open(this.detail.pound.pound_code, this.detail.id, this.detail.order_type === "IB");
    },
    // 国废字段编辑入口只开放包数与放柜区域，避免影响其他既有流程字段。
    onEditGuofeiFields(fieldName) {
      // 当前入口字段直接传给弹窗，确保只编辑并提交对应的国废字段。
      this.$refs.editGuofeiFields.onOpen(this.detail, fieldName);
    },
    // 详情页复用既有装卸点修改弹窗，减少和列表页不同步的操作差异。
    onEditWarehouse() {
      this.$refs.editWarehouse.onOpen(
        this.$route.params.booking_info_id,
        this.isWarehouseEditUnloadOnly
      );
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="less" scoped>
.viewsrhqyAppointDelivery_DeliveryRecordDetail {
  /deep/ .el-form-item {
    margin-bottom: 0;
  }
}
</style>
